import {getMeasurementUnit, MeasurementTypes,} from "@/utils/MeasurementSystem";

const measurementUnit = getMeasurementUnit(MeasurementTypes.ShortDistance);

const SPEED_TYPE_DESC = {
    SPRINT: "Sprint",
    HSR: "HSR",
};

export const generateSpeedTypeOptions = () => {
	return Object.keys(SPEED_TYPE_DESC).map((key) => ({
		text: SPEED_TYPE_DESC[key],
		value: key,
	}));
};

export const generateDistanceBandsOptions = (distanceBands) => {
	return distanceBands.map(d => formatDistanceBandTitle(d, true));
};

export const formatDistanceBandTitle = (distanceBand, includeCountsText = false) => {
	const { id, lowerBoundM, upperBoundM } = distanceBand;
	return {
		text: formatBandTitle(id, lowerBoundM, upperBoundM, includeCountsText),
		value: id
	};
};

// sorts the distance bands into ascending order with the 'TOTAL' as the last element in the Array
export const sortDistanceBands = (distanceBands) => {
	return distanceBands.toSorted((a, b) => {
		if (a.lowerBoundM === null) { // a === TOTAL
			return 1;
		} else if (b.lowerBoundM === null) { // b === TOTAL
			return -1;
		} else {
			return a.lowerBoundM - b.lowerBoundM;
		}
	});
};

const formatBandTitle = (
	id,
	lowerBoundM,
	upperBoundM,
	includeCountsText = false
) => {
	const countsText = includeCountsText ? " Counts" : "";
	if (lowerBoundM != null && upperBoundM != null) {
		return `${measurementUnit.formatCoarse(
			lowerBoundM
		)}-${measurementUnit.formatCoarseUnit(upperBoundM)}${countsText}`;
	} else if (lowerBoundM != null && upperBoundM == null) {
		return `${measurementUnit.formatCoarseUnit(lowerBoundM)}+${countsText}`;
	} else {
		return id;
	}
};

export const generateDistanceBandTitles = (distanceBands, speedTypeKey) => {
	const formattedSpeedType = SPEED_TYPE_DESC[speedTypeKey];
	return distanceBands.reduce((acc, { id, lowerBoundM, upperBoundM }) => {
		acc[id] = `${formattedSpeedType} ${capitaliseFirstLetter(
			formatBandTitle(id, lowerBoundM, upperBoundM)
		)}`;
		return acc;
	}, {});
};

const capitaliseFirstLetter = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
